import { iResultsPanelCalculatorDataItem } from "./ProgressPanel/IsFormFilled"

interface iRangeItem {
  min: number
  max: number
  value: number
}

const getValueFromRange = (value: number, range: iRangeItem[]) => {
  const rangeItem = range.filter(item => value <= item.max && value >= item.min)
  if (rangeItem.length === 0) return 0
  return rangeItem[0].value
}

const getPredictedRisk_v2020 = (
  data: (iResultsPanelCalculatorDataItem | null)[],
  calculatorParameters: { [keyInProgressData: string]: any }
) => {
  console.log("data:", data)
  console.log("calculatorParameters:", calculatorParameters)
  let sum = calculatorParameters["bias"]
  data.forEach(item => {
    if (!item) return
    const param = calculatorParameters[item.key]
    if (!param) return
    const { value } = item
    if (typeof param === "number") {
      sum += parseFloat(value) * param
    } else {
      if (param.range) {
        sum += getValueFromRange(parseFloat(value), param.range)
      } else {
        sum += param[parseInt(value)]
      }
    }
  })

  console.log("sum:", sum)

  // @ts-ignore
  return (Math.exp(sum) / (1 + Math.exp(sum))) * 100
}

export default getPredictedRisk_v2020
